<template>
    <div>
        <p class="subtitle-1 font-weight-medium">
            If you wish to redeem your <span v-if="akv">"Active & Creative Kids Program" voucher or </span>{{ appNameUrls.client }} voucher, please enter the voucher number and voucher pin
            below then click validate.
        </p>
        <v-form class="overwrite-inputs" ref="voucherform" v-model.trim="validVoucherForm" lazy-validation>
            <v-container container--fluid grid-list-lg>
                <v-layout row wrap class="pa-0">
                    <v-flex xs12 sm12 md6>
                        <v-text-field
                            label="Voucher Number"
                            v-model.trim="voucherNumber"
                            :rules="voucherNumberRules"
                            maxlength="50"
                            :error="errorIsVoucher"
                            v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
                            hint="Enter voucher number without spaces or symbols"
                            persistent-hint
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <v-text-field
                            label="Voucher Pin"
                            v-model.trim="voucherPin"
                            :rules="voucherPinRules"
                            maxlength="4"
                            :error="errorIsVoucher"
                            v-mask="'####'"
                            hint="4 digits (DDMM of child DOB)"
                            persistent-hint
                            required
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
        <!-- <v-flex xs12 class="mt-4" v-if="errorIsVoucher && couponErrors.has('error_voucher')">
            <small class="red--text" v-html="couponErrors.get('error_voucher')"></small>
        </v-flex> -->
        <v-flex xs12 class="mt-4" v-if="errorIsVoucher && couponErrors.any()">
            <small class="red--text">{{ getCouponMessage }}</small>
        </v-flex>
        <div class="mt-4">
            <v-btn @click="clearVoucherAndMessage" color="warning" :disabled="couponLoading" class="mr-2 text-left">Clear<v-icon right>clear</v-icon></v-btn>
            <v-btn :loading="couponLoading" :disabled="!validVoucherForm" color="primary" @click="submitVoucher" class="text-left">
                Validate Voucher<v-icon right>child_care</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import store from "./_store";

export default {
    name: "CouponModule",
    props: {
        grandTotal: {
            type: [Number, String],
            required: true,
        },
        akv: {
            type: [Boolean],
            required: false,
        },
    },
    data() {
        return {
            voucherNumber: "",
            voucherNumberRules: [v => !!v || "Voucher Number is required"],
            voucherPin: "",
            voucherPinRules: [v => !!v || "Voucher Pin is required"],

            errorIsVoucher: false,
            validVoucherForm: true,
            // couponApplied: false,
            total: this.grandTotal,
        };
    },
    computed: {
        couponErrors() {
            return this.$store.getters["coupon/couponErrors"];
        },
        couponLoading() {
            return this.$store.getters["coupon/couponStatus"] == "loading";
        },
        getCouponMessage() {
            return this.$store.getters["coupon/couponMessage"];
        },
        couponCart() {
            return this.$store.getters["coupon/couponCart"];
        },
        couponApplied() {
            return this.$store.getters["coupon/couponApplied"];
        },
    },
    methods: {
        clearVoucherAndMessage() {
            this.clearVoucher();
            this.clearMessage();
        },
        clearVoucher() {
            this.$store.dispatch("coupon/clearCouponErrors");
            this.errorIsVoucher = false;
            this.$refs.voucherform.reset();
        },
        clearMessage() {
            this.$store.dispatch("coupon/clearCouponMessage");
        },
        applyVoucher() {
            this.$store.dispatch("coupon/getVoucherTotal", { coupon: this.couponCart, total: this.grandTotal });
        },
        removeVoucher() {
            this.$store.dispatch("coupon/removeVoucher");
            this.validVoucherForm = true;
        },
        removeVoucherError() {
            this.$store.dispatch("coupon/removeVoucherError");
            this.validVoucherForm = true;
        },
        submitVoucher() {
            if (this.$refs.voucherform.validate() && !this.couponApplied) {
                this.validVoucherForm = false;

                const voucherPayload = { voucherNumber: this.voucherNumber, voucherPin: this.voucherPin, akv: this.akv };

                this.$store.dispatch("coupon/clearCouponErrors");

                this.$store
                    .dispatch("coupon/voucherRequest", voucherPayload)
                    .then(coupon => {
                        this.applyVoucher();
                        this.clearVoucher();
                        this.$emit("submitted-voucher");
                    })
                    .catch(err => {
                        this.removeVoucherError();
                        this.validVoucherForm = true;
                        this.errorIsVoucher = true;
                    }).finally(() => {
                        let conf = true;

                        if(parseFloat(this.grandTotal) < parseFloat(this.couponCart.c_value)){
                            conf = confirm('You have nominated to use less than the full value of this voucher. Please note that it does not provide a refund of remaining value. Do you wish to proceed?');
                        }

                        if(!conf){
                            this.removeVoucher();
                        }
                    });
            }
        },
    },
    mounted() {
        //
    },
    created() {
        if (this.$store.getters["coupon/couponApplied"]) {
            this.removeVoucher();
        }
    },
};
</script>

<style scoped></style>
